import { render, staticRenderFns } from "./ChannelNameSearch.vue?vue&type=template&id=6277cd54"
import script from "./ChannelNameSearch.vue?vue&type=script&lang=js"
export * from "./ChannelNameSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports